<template>
	<div class="inner with-content">
		<div class="headline">
			<h1>{{$t('contracts.create.headline')}}</h1>
		</div>
		<div class="content-box small">
			<div class="container">
				<h2>{{$t('contracts.create.type.headline')}}</h2>
				<div class="boxes double">
					<a :href="cols.itemLocked ? '/user/settings' : cols.link" v-for="cols in columns.types" class="col" v-bind:class="{ locked: cols.itemLocked }">
                        <div class="content">
                            <div>
                                <div class="icon">
                                    <img :src="cols.icon">
                                </div>
                                <h3>{{ $t(cols.translationId) }}</h3>
                                <p>{{ $t(cols.translationIdText) }}</p>
                            </div>
                        </div>
                        <div v-if="cols.itemLocked" class="upgrade-banner">
                            <p>{{ $t('upgrade-banner.text') }}</p>
                        </div>
                    </a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	
    import {store} from "../../store";
    import {mapGetters} from 'vuex';
    import SvgIcon from '../../components/Svg.vue';

	export default {
        components: {
            SvgIcon
        },
        computed: {
            ...mapGetters([
                'subscriptionHasLegacyContracts'
            ]),
            columns() {
                return {
                    'types': [
                    {   col: 'digital-contract',
                        link: '/contracts/digital-contract/select-property',
                        svgIcon: '/images/SVG/Dashboard/Contract.svg',
                        icon: '/images/img/dashboard/digital-contract.png',
                     
                        iconHeight: '128px',
                        iconWidth: '146.5px',
                        translationId: 'contracts.create.type.digital.headline',
                        translationIdText: 'contracts.create.type.digital.text'
                    },
                    {   col: 'legacy-contract', 
                        link: '/contracts/select-property',
                        svgIcon: '/images/SVG/Dashboard/Legacy.svg',
                        icon: '/images/img/dashboard/legacy-contract.png',
                        
                        iconHeight: '136px',
                        iconWidth: '132px',
                        translationId: 'contracts.create.type.legacy.headline',
                        translationIdText: 'contracts.create.type.legacy.text',
                        itemLocked: (!this.subscriptionHasLegacyContracts)
                    }
                ]};
            }
        },
        created() {
        }
    }
</script>
<style></style>